import React, { createContext, FC, useMemo, useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Toolbar,
} from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Clear';
import { DiscussionMessageTag } from '../../common/constants';
import Typography from '@material-ui/core/Typography';
import useStyles from './styles';

export interface IDiscussionFilter {
  tags: string[];
  filter: string;
}

export const DiscussionFilterContext = createContext<IDiscussionFilter>({
  tags: [],
  filter: '',
});

const DiscussionFilterProvider: FC = ({ children }) => {
  const classes = useStyles();
  const [tags, setTags] = useState<string[]>([]);
  const [filter, setFilter] = useState<string>('');

  const value = useMemo(
    () => ({
      tags,
      filter,
    }),
    [tags, filter],
  );

  return (
    <DiscussionFilterContext.Provider value={value}>
      <Toolbar className={classes.toolBar}>
        <Box className={classes.leftToolbarContainer}>
          <Typography noWrap className={classes.title} variant="h6">
            Liste des discussions
          </Typography>
          <Button
            disableRipple
            variant="outlined"
            size="small"
            color={tags?.length ? 'secondary' : 'primary'}
            startIcon={<FilterListIcon />}
            onClick={() =>
              setTags(!tags?.length ? [DiscussionMessageTag.FEEDBACK] : [])
            }>
            Feedbacks
          </Button>
        </Box>
        <TextField
          value={filter}
          className={classes.search}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className={classes.searchIcon} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton disabled={!filter} onClick={() => setFilter('')}>
                  <CloseIcon className={classes.clearIcon} />
                </IconButton>
              </InputAdornment>
            ),
          }}
          placeholder="Chercher"
          variant="outlined"
          onChange={(e) => {
            setFilter(e.target.value);
          }}
        />
      </Toolbar>
      {children}
    </DiscussionFilterContext.Provider>
  );
};

export default DiscussionFilterProvider;
